import type { SdkAuthConfig } from '@Pages/pageRuntime/sdk/types';
import { createContext } from 'react';

/**
 * The server-built auth catalog for the rendered surface, provided by
 * `PageRenderer` from its `auth` prop. Components like `LoginForm` read it
 * here rather than from Inertia page props, because the prop name and nesting
 * differ per surface (live page, page editor, component editor preview).
 */
export const PageAuthContext = createContext<SdkAuthConfig | null>(null);
